import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/shared/config';
import { PageLayout, Skeleton } from '@/shared/ui';

/**
 * Экран, пока грузится чанк страницы (`lazyPage` в `app/router`): та же шапка
 * и тот же скелет строк, что `HistoryPage` показывает, пока ждёт список, —
 * загрузка кода и данных идёт одним шиммером.
 */
export function HistoryPageSkeleton() {
  const { t } = useTranslation('HistoryPage');
  const navigate = useNavigate();
  return (
    <PageLayout title={t('title')} onBack={() => void navigate(ROUTES.home)}>
      <HistorySkeleton />
    </PageLayout>
  );
}

export function HistorySkeleton() {
  const { t } = useTranslation('HistoryPage');
  return (
    <div aria-busy="true" aria-live="polite" className="flex flex-col">
      <span className="sr-only">{t('loadingSr')}</span>
      {[0, 1, 2, 3].map((index) => (
        <div key={index} className="flex items-center gap-3 border-b border-hairline py-3 last:border-b-0">
          <Skeleton className="size-13 shrink-0 rounded-full" />
          <div className="flex min-w-0 flex-1 flex-col gap-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3.5 w-48" />
          </div>
        </div>
      ))}
    </div>
  );
}
